import React from 'react'
;
import { Link } from 'react-router-dom';

const StudentArea = () => {

    

    return (
        <div className="students-join1-area">
            <div className="container">
                <div className="students-join1-wrapper">
                    <div className="students-join1-left">
                        <div id="ri-grid" className="author-banner-bg ri-grid header text-center">
                            <ul className="ri-grid-list">
                                <li>
                                    <a href="#"><img src="/images/1.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/2.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/3.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/4.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/5.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/6.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/7.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/8.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/9.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/10.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/11.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/12.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/13.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/14.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/15.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/16.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/17.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/18.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/19.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/20.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/21.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/22.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/23.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/24.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/25.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/26.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/27.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/1.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/2.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/3.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/4.jpg" alt /></a>
                                </li>
                                <li>
                                    <a href="#"><img src="/images/5.jpg " alt /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="students-join1-right">
                        <div>
                            <a><img src="/images/org.png" alt="image" /></a>
                            <h2>Our<span> Job Oriented</span> Courses.</h2>
                            <Link to='/allcourses' className="join-now-btn">View More Courses</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { StudentArea};